import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    AfterViewInit,
    ElementRef,
    ViewChild,
    HostListener,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LabService } from '../../services/lab.service';
import {
    ILabChildOrder,
    ILabOrder,
    TPrintResponse,
} from '../../interfaces/lab.interface';
import { lastValueFrom } from 'rxjs';
import { HttpNewService } from 'src/app/services/application/http-new.service';

import { AlertService } from 'src/lib/ariadna/alert';

@Component({
    selector: 'app-reseach-child-modal',
    templateUrl: './reseach-child-modal.component.html',
    styleUrls: ['./reseach-child-modal.component.scss'],
    standalone: false,
})
export class ReseachChildModalComponent implements OnInit {
    @Input() pickedResearch: any;
    @Output() close = new EventEmitter<void>();
    private htmlEncodedObj: Record<string, string> = {
        '&gt;': '> больше',
        '&lt;': '< меньше',
    };

    protected loadingList = false;
    protected reseachChild: any = [];

    protected researchBlocks: any[] = [];

    constructor(
        private lab: LabService,
        private http: HttpNewService,
        private alert: AlertService
    ) {}

    @ViewChild('modalBody')
    modalBody!: ElementRef;
    @ViewChild('header')
    header!: ElementRef;
    isMobile: boolean = false;
    isClosing: boolean = false;

    ngOnInit(): void {
        this.checkScreenSize();
        this.loadingList = true;
        this.selectOrderChild(this.pickedResearch);
    }

    ngAfterViewInit() {
        if (this.modalBody && this.modalBody.nativeElement) {
            this.modalBody.nativeElement.addEventListener(
                'scroll',
                this.handleScroll.bind(this)
            );
        }
    }

    ngOnDestroy() {
        if (this.modalBody && this.modalBody.nativeElement) {
            this.modalBody.nativeElement.removeEventListener(
                'scroll',
                this.handleScroll
            );
        }
    }
    handleScroll() {
        if (this.modalBody && this.header) {
            const scrollTop = this.modalBody.nativeElement.scrollTop;

            if (scrollTop > 0) {
                this.header.nativeElement.classList.add('scrolled');
            } else {
                this.header.nativeElement.classList.remove('scrolled');
            }
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.checkScreenSize();
    }

    private checkScreenSize(): void {
        this.isMobile = window.innerWidth <= 767;
    }

    closeModal(event?: Event): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (this.isMobile) {
            this.isClosing = true;
            setTimeout(() => {
                this.close.emit();
            }, 300); // Match the animation duration
        } else {
            this.close.emit();
        }
    }

    public selectOrderChild(order: ILabChildOrder['research_child_list'][0]) {
        if (!order) {
            console.error('No order provided');
            this.loadingList = false;
            return;
        }

        this.loadingList = true;

        const type = order.ext_results
            ? 'ext'
            : order.internal_order
            ? 'int'
            : 'ext';

        this.lab
            .getLaboratoryChildResearch(null, order.research_id, type)
            .subscribe(
                (res) => {
                    this.reseachChild = res;
                    this.processResearchData();
                    this.loadingList = false;
                },
                (error) => {
                    console.error('Error loading research data:', error);
                    this.loadingList = false;
                }
            );
    }

    private processResearchData(): void {
        this.researchBlocks = [];
        let currentBlock: any = null;

        this.reseachChild.forEach((child: any, index: number) => {
            if (child.headermark === 1 || index === 0) {
                if (currentBlock) {
                    this.researchBlocks.push(currentBlock);
                }

                currentBlock = {
                    showHeader:
                        index === 0 || (child.headermark === 1 && index === 1),
                    title:
                        child.headermark === 1 ? child.measur : child.srv_text,
                    items: [],
                };

                if (
                    child.headermark === 1 &&
                    child.text &&
                    child.text.length > 15
                ) {
                    currentBlock.items.push(child);
                } else if (child.headermark !== 1) {
                    currentBlock.items.push(child);
                } else if (child.headermark === 1 && child.specimen_text) {
                    currentBlock.items.push(child);
                }
            } else if (
                child.headermark === 1 &&
                typeof child.measur === 'string' &&
                child.measur.toLowerCase() === 'заключение'
            ) {
                currentBlock.items.push(child);
            } else {
                currentBlock.items.push(child);
            }
        });

        if (currentBlock) {
            this.researchBlocks.push(currentBlock);
        }
    }

    decodeUnicode(text: string): string {
        return this.htmlEncodedObj[text];
    }

    isRotate(dist: string | null): boolean {
        return dist === '&lt;';
    }

    // closeModal(e: Event) {
    //     e.stopPropagation();
    //     this.close.emit();
    // }

    stringRedact(string: string) {
        if (string.length < 20) {
            return;
        } else {
        }
    }
    // isPdfLoading: boolean = false;
    public loadingPdfIds: Set<number> = new Set();
    // async goPdf(
    //     researchId: number | undefined,
    //     e: Event,
    //     ext: number,
    //     int: number
    // ) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     if (!researchId) return;
    //     const type: string = int === 1 ? 'int' : 'ext';

    //     this.loadingPdfIds.add(researchId);
    //     try {
    //         const res = (await lastValueFrom(
    //             this.http.get(
    //                 this.getDownloadUrlForPDF(researchId, type),
    //                 null,
    //                 false
    //             )
    //         )) as TPrintResponse;
    //         if (res && res.reportlist) {
    //             this.printNlab(res.reportlist[0].pdf);
    //             return;
    //         }

    //         if (res) {
    //             const binaryString = res.response.data;
    //             const bytes = new Uint8Array(binaryString.length);
    //             for (let i = 0; i < binaryString.length; i++) {
    //                 bytes[i] = binaryString[i];
    //             }

    //             const file = new Blob([bytes.buffer], {
    //                 type: 'application/pdf',
    //             });
    //             const fileURL = URL.createObjectURL(file);

    //             // Для Safari на iOS используем создание ссылки
    //             const isSafari = /^((?!chrome|android).)*safari/i.test(
    //                 navigator.userAgent
    //             );
    //             const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    //             if (isSafari && isIOS) {
    //                 const link = document.createElement('a');
    //                 link.href = fileURL;
    //                 link.target = '_blank';
    //                 link.rel = 'noopener';
    //                 link.download = `research_${researchId}.pdf`;
    //                 document.body.appendChild(link);
    //                 link.click();
    //                 document.body.removeChild(link);
    //                 setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
    //             } else {
    //                 const emptyPage = window.open('about:blank', '_blank');
    //                 if (emptyPage) {
    //                     emptyPage.location.href = fileURL;
    //                 }
    //             }
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         this.alert.error('Ошибка загрузки');
    //     } finally {
    //         this.loadingPdfIds.delete(researchId);
    //     }
    // }

    async goPdf(
        researchId: number | undefined,
        e: Event,
        ext: number,
        int: number
    ) {
        e.preventDefault();
        e.stopPropagation();
        if (!researchId) return;
        const type: string = ext === 1 ? 'ext' : 'int';

        this.loadingPdfIds.add(researchId);

        try {
            const res = (await lastValueFrom(
                this.http.get(
                    this.getDownloadUrlForPDF(researchId, type),
                    null,
                    false
                )
            )) as TPrintResponse;

            if (res && res.reportlist) {
                const base64 = res.reportlist[0].pdf;
                this.printNlab(base64); // Обновлённый метод
                return;
            }

            if (res) {
                const binaryString = res.response.data;
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString[i];
                }

                const file = new Blob([bytes.buffer], {
                    type: 'application/pdf',
                });
                const fileURL = URL.createObjectURL(file);

                window.location.href = fileURL;

                setTimeout(() => URL.revokeObjectURL(fileURL), 10000);

                // Для Safari на iOS используем создание ссылки
                // const isSafari = /^((?!chrome|android).)*safari/i.test(
                //     navigator.userAgent
                // );
                // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

                // if (isSafari && isIOS) {
                //     const link = document.createElement('a');
                //     link.href = fileURL;
                //     link.target = '_blank';
                //     link.rel = 'noopener';
                //     link.download = `research_${researchId}.pdf`;
                //     document.body.appendChild(link);
                //     link.click();
                //     document.body.removeChild(link);
                //     setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
                // }
            }
        } catch (error) {
            console.error(error);
            this.alert.error('Ошибка загрузки');
        } finally {
            this.loadingPdfIds.delete(researchId);
        }
    }

    // private printNlab(base64: string): void {
    //     const binaryString = atob(base64);
    //     const bytes = new Uint8Array(binaryString.length);
    //     for (let i = 0; i < binaryString.length; i++) {
    //         bytes[i] = binaryString.charCodeAt(i);
    //     }
    //     const emptyPage = window.open('about:blank', '_blank');
    //     if (emptyPage) {
    //         const file = new Blob([bytes.buffer], {
    //             type: 'application/pdf',
    //         });
    //         const fileURL = URL.createObjectURL(file);
    //         emptyPage.location.href = fileURL;
    //         setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
    //     }
    // }

    private printNlab(base64: string): void {
        const binaryString = atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        const file = new Blob([bytes.buffer], {
            type: 'application/pdf',
        });
        const fileURL = URL.createObjectURL(file);

        window.location.href = fileURL;

        setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
    }

    isPdfLoading(researchId: number | undefined): boolean {
        return researchId ? this.loadingPdfIds.has(researchId) : false;
    }

    getDownloadUrlForPDF(researchId: number | undefined, type: string) {
        return `/labs/pdf/${researchId}.pdf?type=${type}`;
    }
}
